<template>
  <div id="ServiceCodes">
    <b-modal
      id="modal-msg"
      class="test-modal"
      size="lg"
      title="Manage Service Code"
      v-model="showInfoModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div slot="default">
        <div class="alert alert-warning" role="alert" v-if="!succeeded">
          {{ Msg }} <br />
          Please Contact System Administrator.
        </div>
        <div class="alert alert-success" role="alert" v-if="succeeded">
          {{ Msg }}
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button
          variant="primary"
          size="md"
          class="float-right BtnClose"
          @click="CloseMsgPopup"
        >
          Close
        </b-button>
      </div>
    </b-modal>

    <b-modal
      id="editModal"
      v-model="cloneOrAdd"
      scrollable
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      hide-header-close
      ok-variant
      cancel-variant
      header-class="PopUpHeader"
      :body-bg-variant="PopUpVar.bodyBgVariant"
      :body-text-variant="PopUpVar.bodyTextVariant"
      :footer-bg-variant="PopUpVar.footerBgVariant"
      :footer-text-variant="PopUpVar.footerTextVariant"
    >
      <p class="text-center m-0">
        Use Service Code for default values or Clone
      </p>
      <p class="text-center">
        (Can only clone Service Codes with an expiry Date)
      </p>
      <div class="row">
        <div class="col-3 p-0 m-0">
          <button
            v-on:click="CloneServiceTypePopup('CloneAdd')"
            type="button"
            class="btn float-right BtnSave btn-sml"
          >
            <i :class="saveIcon"></i>Add
          </button>
        </div>
        <div class="col-3 p-0 m-0">
          <!-- <button :disabled="cloneRow.canclone=='No'" v-on:click="CloneServiceTypePopup('Clone')" type="button" class="btn  float-right BtnSave  btn-sml"> <i class="fas fa-copy"></i>Clone</button> -->
          <button
            v-on:click="CloneServiceTypePopup('Clone')"
            type="button"
            class="btn float-right BtnSave btn-sml"
          >
            <i class="fas fa-copy"></i>Clone
          </button>
        </div>
        <div class="col-4 p-0 mr-1">
          <button
            v-on:click="CloseClone"
            type="button"
            class="btn BtnClose btn-sml float-right"
          >
            <i class="fas fa-times"></i> Close Form
          </button>
        </div>
      </div>
      <template slot="modal-header">
        <div>
          <small class="modal-title w-40 text-left"></small>
        </div>
        <div>
          <small class="PopUpTitle">{{ mode }} Service Code Standard</small>
        </div>
        <div>
          <small class="modal-title w-100 text-right"></small>
        </div> </template
    ></b-modal>

    <Subtitle v-bind:ServiceID="this.AppServiceID">
      <template v-slot:header>
        <i class="fas fa-qrcode"></i><b> Manage Service Code Standard:</b>
      </template></Subtitle
    >
    <Card>
      <CardBody>
        <p>
          Manage Service Code is an Administration action. Any change in this
          section will affect the web application and its access level. All
          transactions are monitored, logged and reviewed.
        </p>
      </CardBody>
    </Card>

    <b-modal
      id="AddModal"
      modal-class="fullScreen  fade"
      v-model="showModal"
      scrollable
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      hide-header-close
      ok-variant
      cancel-variant
      header-class="PopUpHeader"
      :header-text-variant="PopUpVar.headerTextVariant"
      :body-bg-variant="PopUpVar.bodyBgVariant"
      :body-text-variant="PopUpVar.bodyTextVariant"
      :footer-bg-variant="PopUpVar.footerBgVariant"
      :footer-text-variant="PopUpVar.footerTextVariant"
    >
      <ServiceCodeAddEdit
        v-if="showModal == true"
        :status="status"
        :PropServiceCode="ServiceCode"
        :Mode="mode"
        @ServiceCodeExit="closeModal"
      ></ServiceCodeAddEdit>
      <template slot="modal-header">
        <div>
          <small class="PopUpTitle text-right">
            {{ mode }} Service Code Standard</small
          >
        </div>
        <div><small class="PopUpTitle"></small></div>
        <div v-if="mode == 'Edit'">
          <small class="PopUpTitle w-100 h-10 text-right"></small
          ><small>Service Code: {{ ServiceCode.serviceCode }}</small>
        </div>
      </template></b-modal
    >
<v-client-table :columns="columns" :data="tableData" :options="options">
<template slot="status" slot-scope="props">
  <span>{{ props.row.status }}</span>
</template>

<span class="pointer" v-on:click="EditServiceCodePopup(props.row)" slot="edit" slot-scope="props" > <i class="far fa-edit"></i></span>  
<span class="pointer" v-on:click="ViewServiceCodePopup(props.row)" slot="view" slot-scope="props" >  <i class="far fa-question-circle"></i></span>
<!-- v-b-tooltip title="View Details" ></i></span>  -->
     
<span class="pointer" v-on:click="CloneType(props.row)" slot="clone" slot-scope="props"> <i class="fas fa-copy"></i></span>  

<div  slot="beforeFilter"  class="VueTables_Adduser" v-show="showEdit">
<label for="VueTables_AddServiceCode"  class="VueTables_user"> Add New Service Code: </label>
<button type="button" v-on:click="AddServiceCodePopup" class="btn btn-primary form-control ">ADD Service Code</button>
</div>
</v-client-table>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Vue from "vue";
import moment from "moment";
import Modal from "../../../Common/ModelPop.vue";
import { PopUpVariant } from "@/Common/Default/PopUpVariant";
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import ServiceCodeAddEdit from "@/components/DPEBB/Administrator/ServiceCodeAddEdit.vue";
import { constants } from "crypto";
import Subtitle from "@/Common/Default/SubTitle.vue";
export default {
  props: {
    AllowEdit: { type: Boolean, required: true },
  },
  data: function () {
    return {
      succeeded: false,
      Msg: "",
      status: "",
      saveIcon: "fas fa-plus",
      cloneOrAdd: false,
      AppServiceID: 6,
      cloneRow: "",
      viewOnly: false,
      showInfoModal: false,
      showModal: false,
      PopUpVar: PopUpVariant,
      ServiceCode: [],
      statusShow: false,
      mode: "",
      columns: [
        "status",
        "view",
        "edit",
        "clone",
        "servicetype",
        "servicecode",
        "description",
        "effectivedate",
        "expirydate",
      ],
      tableData: [],

      options: {
        texts: {
          count:
            "Showing {from} to {to} of {count} records|{count} records|One record",
          first: "First",
          last: "Last",
          filter: "Search Service Code Data:",
          filterPlaceholder: "Search in table",
          limit: "Records:",
          page: "Page:",
          noResults: "No matching records",
          filterBy: "Filter by {column}",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns",
        },

        responseAdapter({ data }) {
          return {
            data: formatData,
            count: data.length,
          };
        },

        perPage: 10,
        perPageValues: [10, 15, 25],
        dateColumns: ["effectivedate", "expirydate"],
        toMomentFormat: "YYYY-MM-DD",

        templates: {
          effectivedate(h, row) {
            return moment(row.effectivedate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
          expirydate(h, row) {
            return moment(row.expirydate, "YYYY-MM-DD").format("YYYY/MM/DD");
          },
//          status(h, row) {

            //return row.status;
            // if (row.status === "ACTIVE") { 
            //   return (
                
            //     <span style="color:green" v-b-tooltip title="Active">
            //     <span style="display:none"> {row.status}</span>
            //       <i class="fas fa-check-circle"></i>
            //     </span>
            //   );
            // } else if (row.status === "FUTURE") {
            //   return (
            //     <span style="color:red" v-b-tooltip title="Future Dated">
            //       <span style="display:none"> {row.status}</span>
            //       <i class="fa fa-arrow-circle-right"></i>
            //     </span>
            //   );
            // } else if (row.status === "INACTIVE") { 
            //   return (
            //     <span style="color:red" v-b-tooltip title="Inactive">
            //       <span style="display:none"> {row.status}</span>
            //       <i class="fas fa-times-circle"></i>
            //     </span>
            //   );
            // }
///          },

            // if((moment(row.effectivedate)).toISOString() > moment().startOf('day').toISOString()){
            //     return <span style="color:red" v-b-tooltip title="Future Dated"><i class="fa fa-arrow-circle-right"></i></span>
            //     }
            // if((moment(row.expirydate)).toISOString() <= moment().startOf('day').toISOString()){
            //     return <span style="color:red" v-b-tooltip title="Inactive"><i class="fas fa-times-circle"></i></span>
            //     }
            // else
            //     return <span style="color:green" v-b-tooltip title="Active"><i class="fas fa-check-circle" ></i></span>
          
          // if((moment(row.effectivedate)).toISOString() > moment().startOf('day').toISOString()){
          //     return <span style="color:red" v-b-tooltip title="Future Dated"><i class="fa fa-arrow-circle-right"></i></span>
          //     }
          // if((moment(row.expirydate)).toISOString() <= moment().startOf('day').toISOString()){
          //     return <span style="color:red" v-b-tooltip title="Inactive"><i class="fas fa-times-circle"></i></span>
          //     }
          // else
          //     return <span style="color:green" v-b-tooltip title="Active"><i class="fas fa-check-circle" ></i></span>

          // if(row.status='FUTURE'){
          //     return <span style="color:red" v-b-tooltip title="Future Dated"><i class="fa fa-arrow-circle-right"></i></span>
          //     }
          // if(row.status = 'INACTIVE'){
          //     return <span style="color:red" v-b-tooltip title="Inactive"><i class="fas fa-times-circle"></i></span>
          //     }
          // else if(row.status = 'ACTIVE'){
          //     return <span style="color:green" v-b-tooltip title="Active"><i class="fas fa-check-circle" ></i></span>
          // }
        },
        // ['status','view', 'edit' , 'clone', 'servicetype','servicecode','description','effectivedate','expirydate'],
        headings: {
          status: "Status",
          view: "View",
          edit: "Edit",
          clone: "Clone",
          //clinicno: 'Clinic #',
          servicetype: "Service Type",
          servicecode: "Service Code",
          description: "Description",
          effectivedate: "Effective Date",
          expirydate: "Expiry Date",
        },
        pagination: {
          edge: true,
          nav: "scroll",
          chunk: 5,
        },
        // sortable: ['status','servicetype','servicecode','description','effectivedate','expirydate'],
        filterable: [
          "status",
          "servicetype",
          "servicecode",
          "description",
          "effectivedate",
          "expirydate",
        ],
        sortable: [
          "status",
          "servicetype",
          "servicecode",
          "description",
          "effectivedate",
          "expirydate",
        ],
        sortIcon: {
          base: "fas",
          is: "fa-sort",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
      },
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.loadTable();
      //this.$refs.table.refresh();
    },
    CloseMsgPopup() {
      this.showInfoModal = false;
    },

    AddServiceCodePopup(Rowdata) {
      this.ServiceCode = "";
      this.showModal = true;
      this.mode = "Add";
    },
    showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          console.log("at value " + value);
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    ViewServiceCodePopup(Rowdata) {
      var vm = this;
      vm.mode = "View";
      var params = new URLSearchParams();
      //console.log("ViewServiceCodePopup");
      params.append("Dbkey", Rowdata.dbkey);
      axios
        .get("SaskHealthApi/Host/GetServiceCodeStandard?_=" + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response){
          console.log(' SC MF = ' +response.data.isRetired)
          vm.ServiceCode = response.data;
          vm.showModal = true;
        })
        .catch(function (er) {
          console.log(' at Error ' + er);

          console.log('here')
            //    vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");

                if (er.response) {
                            if(er.response.status == 400)
                                {
                                        if( er.response.data.message.length)
                                        {
                                        vm.showMsg(er.response.data.message,"","Service Code Error");

                                        }
                                }
                        }
                        else 
                        vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");
                               


          // if (er.status == 400) {
          //   vm.showModal = false;
          //   vm.showInfoModal = true;
          //   vm.succeeded = false;
          //   vm.Msg =
          //     "Warning: Service Code not successfully loaded. " +
          //     " ( " +
          //     er.data.message +
          //     ").";
          // } else if (er.status == 500) {
          //   vm.showModal = false;
          //   vm.showInfoModal = true;
          //   vm.succeeded = false;
          //   console.log('at 500')
          //   if (er.data.message != null) vm.Msg = er.data.message;
          //   else
          //   {
          //     console.log('at else')
          //     vm.Msg =
          //       "Network Related Error ! Please contact system administrator.";
          //       vm.showInfoModal = true;
          //       vm.succeeded = false;
          //   }
          // }
          // else

          // {
          //       console.log('here')
          //       vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");
               
          // }

        });
    },
    GetStatus(effectDate, ExpiryDate) {
      this.status = "";
      console.log(ExpiryDate)
      if (
        moment(effectDate).toISOString() > moment().startOf("day").toISOString()
      ) {
        this.status = "FUTURE";
        return this.status;
      }
      if (
        moment(ExpiryDate).toISOString() <=
        moment().startOf("day").toISOString()
      ) {
        //console.log('Expiry Date ' +moment(ExpiryDate).toISOString())
        //console.log('todays' +moment().startOf("day").toISOString())
        this.status = "INACTIVE";
        return this.status;
      } else {

        this.status = "ACTIVE";
        return this.status;
      }
    },
    EditServiceCodePopup(Rowdata) {
      var vm = this;
      vm.status = Rowdata.status;
      //vm.GetStatus(Rowdata.effectivedate, Rowdata.expirydate);
      // if(vm.GetStatus(Rowdata.effectivedate, Rowdata.expirydate) == "INACTIVE"){
      //      vm.mode = 'INACTIVE';
      // }
      // else if(vm.GetStatus(Rowdata.effectivedate, Rowdata.expirydate) == "ACTIVE")
      // {
      //     vm.mode = 'ACTIVE';
      // }
      //     else if(vm.GetStatus(Rowdata.effectivedate, Rowdata.expirydate) == "FUTURE")
      // {
      //     vm.mode = 'FUTURE';
      // }
      //console.log('status = '+vm.status);

      vm.mode = "Edit";
      var params = new URLSearchParams();
      //console.log("EditServiceCodePopup");
      //console.log(Rowdata.dbkey);
      params.append("Dbkey", Rowdata.dbkey);
      axios
        .get("SaskHealthApi/Host/GetServiceCodeStandard?_=" + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.ServiceCode = response.data;
          console.log(response.data);
          vm.showModal = true;
        })
        .catch(function (er) {

          console.log('here')
               // vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");

                if (er.response) {
                            if(er.response.status == 400)
                                {
                                        if( er.response.data.message.length)
                                        {
                                        vm.showMsg(er.response.data.message,"","Service Code Error");

                                        }
                                }
                        }
                        else 
                        vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");
                                
          // console.log(er);
          // if (er.status == 400) {
          //   console.log("At 400");
          //   vm.showModal = false;
          //   vm.showInfoModal = true;
          //   vm.succeeded = false;
          //   vm.Msg =
          //     "Warning: Service Code not successfully loaded. " +
          //     " ( " +
          //     er.data.message +
          //     ").";
          // } else if (er.status == 500) {
          //   vm.showModal = false;
          //   vm.showInfoModal = true;
          //   vm.succeeded = false;
          //   if (er.data.message != null) vm.Msg = er.data.message;
          //   else
          //     vm.Msg =
          //       "Network Related Error ! Please contact system administrator.";
          // }


        });
    },
    CloneType(Rowdata) {
      var vm = this;
      vm.mode = "Clone";
      this.cloneOrAdd = true;
      this.cloneRow = Rowdata;
    },
    CloseClone() {
      this.cloneOrAdd = false;
    },
    CloneServiceTypePopup(clonemode) {
      this.cloneOrAdd = false;
      var vm = this;
      vm.mode = clonemode;
      var params = new URLSearchParams();
      //console.log("CloneServiceTypePopup");
      params.append("Dbkey", vm.cloneRow.dbkey);
      axios
        .get("SaskHealthApi/Host/GetServiceCodeStandard?_=" + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.ServiceCode = response.data;
          vm.showModal = true;
          //console.log(response.data);
        })
        .catch(function (er) {
          console.log('here')
                //vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");
                if (er.response) {
                            if(er.response.status == 400)
                                {
                                        if( er.response.data.message.length)
                                        {
                                        vm.showMsg(er.response.data.message,"","Service Code Error");

                                        }
                                }
                        }
                        else 
                        vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");
                                
          // console.log(er);
          // if (er.status == 400) {
          //   vm.showModal = false;
          //   vm.showInfoModal = true;
          //   vm.succeeded = false;
          //   vm.Msg =
          //     "Warning: Service Code not successfully loaded. " +
          //     " ( " +
          //     er.data.message +
          //     ").";
          // } else if (er.status == 500) {
          //   vm.showModal = false;
          //   vm.showInfoModal = true;
          //   vm.succeeded = false;
          //   if (er.data.message != null) vm.Msg = er.data.message;
          //   else
          //     vm.Msg =
          //       "Network Related Error, Please contact system administrator.";
          // }
        });
    },
    loadTable() {
      var vm = this;
      ///console.log("loadTable");
      axios
        .get("SaskHealthApi/Codes/GetServiceCodeStandard?_=" + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
        })
        .then(function (response) {
          vm.tableData = response.data;
        })
        .catch(function (er) {
          console.log(er);
          console.log('here')
                vm.showMsg("Network Related Error ! Please contact system administrator.","","Service Code Error");

        });
    },
  },
  created: function () {
    this.showEdit = this.AllowEdit;
    this.viewOnly = !this.AllowEdit;
    if (this.viewOnly) {
      var i;
      for (i = 0; i < this.columns.length; i++) {
        //remove the edit and clone columns entirely, this user can only view
        if (
          this.columns[i].toUpperCase() == "EDIT" ||
          this.columns[i].toUpperCase() == "CLONE"
        ) {
          this.columns.splice(i, 1);
          i--;
        }
      }
    }

    this.loadTable();
  },
  computed: {},
  components: {
    Modal: Modal,
    // ServiceTypeAddEdit:ServiceTypeAddEdit,
    Card,
    CardBody,
    TileNote,
    ServiceCodeAddEdit,
    Subtitle,
    // VSelect
  },
};
</script>

<style scopped>
.modal-open {
  padding: 0 !important;
  padding-left: 0px !important;
  overflow-y: scroll;
}

#AddModal {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* .modal .modal-huge {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
} */
/* .AddModal .modal-dialog {
max-width: 100%;
margin: 0;
top: 0;
bottom: 0;
left: 0;
right: 0;
height: 100vh;
display: flex;
z-index: 100000;
} */

/* .editModal .modal-dialog {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
}

.test-modal .modal-dialog {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  -webkit-transition: opacity 0.3s ease;
  transition: opacity 0.3s ease;
} */
</style>
